import { useEffect, useState } from "react";
import DocumentiFieraTable from "./DocumentiFieraTable";
import { Card, Icon } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CaricaFile from "./CaricaFile";
import UtilityService from "services/API/utility/UtilityService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import MDTypography from "common/components/MD/MDTypography";
import SpazioComponent from "./SpazioComponent";
import { MobileFriendly } from "@mui/icons-material";
import MDBox from "common/components/MD/MDBox";
import SpazioComponentMini from "./SpazioComponentMini";


function DocumentiFieraComponent({ richiesta, filtra }) {

    const [lista_moduli, setLista_moduli] = useState([]);
    useEffect(() => {

        setLista_moduli(richiesta.moduli_obbligatori);
    }, []);

    async function download_pdf_modello(idModello, nome_file) {

        UtilityService.downloadModulo(idModello)
            .then(response => {

                return response.data;
            })
            .then(blob => {

                var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                var url = URL.createObjectURL(blobb);
                var a = document.createElement('a');
                a.href = url;
                a.target = "_blank";

                a.download = nome_file;
                ;

                document.body.appendChild(a); // append the element to the dom
                a.click();
                a.remove(); // afterwards, remove the element  
            })
            .catch(error => {
                console.error(error);
            });




    }



    const righe = [];
    const icona = (<Icon fontSize="small" color="success" ml={15}>drawicon</Icon>);


    lista_moduli.forEach((modulo) => {

        righe.push({
         
            icona: icona,
            modulo: modulo,
            idRichiesta: richiesta.idRichiesta,
            nome_modulo: modulo.nome_modulo,
            nome_modello: modulo.modello.nome_modulo,
            modello: modulo.modello,
            modulo_da_compilare: (<MDTypography variant="button" fontWeight="regular" color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                onClick={() => download_pdf_modello(modulo.modello.idFile, modulo.modello.nome_file)}
            >{modulo.modello.nome_file}
            </MDTypography>),
            modulo_compilato: (<CaricaFile id_richiesta={richiesta.idRichiesta} modulo={modulo} filtra={filtra} />),
            protocollato: (modulo.protocollato ? <CheckCircleIcon color="success" /> : "No"),

        })

    }




    )


    const ppTableData = {
        rows: righe,

        columns: [


            { Header: "Modulo", accessor: "nome_modello", width: "20%", align: "left", id: "documenti_1" },
            { Header: "Scarica il Modulo da Compilare", accessor: "modulo_da_compilare", align: "left", with: "15%", id: "documenti_2" },
            { Header: "Ricarica il Modulo Compilato", accessor: "modulo_compilato", align: "left", id: "documenti_3" },
            { Header: "Validato", accessor: "protocollato", align: "left", width: "10%", id: "documenti_4" },
        ],



    };



    return (
        <MDBox>
    
            <SpazioComponentMini
                key={richiesta.idRichiesta}
                id={richiesta.idRichiesta}
                richiesta={richiesta}
            />
            <MDBox mx={10}>
                <MDBox mb={2} ><MDTypography color='success'>Moduli Obbligatori</MDTypography></MDBox>
            <DocumentiFieraTable
                canSearch={false}
                table={ppTableData}
                nome_tabella="documenti"
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
                responsive={true}
                filtro_server={false}
                canExport={false}
                canSend={false}
                enableColumnFilters={false}

            />
        </MDBox>
        </MDBox>
    );

}
export default DocumentiFieraComponent;
